export default "__VITE_ASSET__CH8Bxz_C__"